// store/thunks/auth/resendPhoneCodeThunk.ts
import { createAdminAsyncThunk } from '@/store/thunks/createAdminAsyncThunk';
import { VerificationDTO } from '@/types/dtos.types';

export const resendPhoneCodeThunk = createAdminAsyncThunk<
  VerificationDTO,
  undefined,
  { rejectValue: { message: string } }
>(
  'auth/resendPhoneCode',
  async(_, { extra: { authService }, rejectWithValue }) => {

    try {
      return await authService.resendPhoneCode();
    } catch (caught) {
      const message =
        caught instanceof Error ? caught.message : 'Failed to resend email code';
      return rejectWithValue({ message });
    }
  }
);

